import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataIterator } from 'vuetify/lib/components/VDataIterator';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-virtual-device-smart-group-create-dialog', {
    attrs: {
      "isOpen": _vm.showCreateDialog,
      "editItem": _vm.editItem
    },
    on: {
      "close": function ($event) {
        _vm.editItem = {};
        _vm.showCreateDialog = false;
      },
      "save": _vm.handleCreate,
      "update": _vm.handleUpdate
    }
  }), _c('core-prompt', {
    attrs: {
      "title": _vm.deletePromptTitle,
      "open": _vm.showDeletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete',
        disabled: _vm.isLoadingAlarmReports || _vm.hasLinkedAlarmReports
      }]
    },
    on: {
      "delete": _vm.handleConfirmedDelete,
      "cancel": function ($event) {
        _vm.showDeletePrompt = false;
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.hasLinkedAlarmReports ? _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.deletePrompt.linkedAlarmReportsDescription') : _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.deletePrompt.text')) + "\n    "), _vm.hasLinkedAlarmReports ? [_c('div', {
    staticStyle: {
      "height": "400px",
      "overflow-y": "auto"
    }
  }, [[_c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.linkedAlarmReports,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({}) {
        return [_c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-file-exclamation`)
          }
        })];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [[_c('a', {
          attrs: {
            "href": `/#/alarm-log-reports`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.get(item, 'meta.title')))])], _vm._v("\n               \n              "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 663437337)
  })]], 2)] : _vm.isLoadingAlarmReports ? [_c(VSkeletonLoader, {
    attrs: {
      "type": "list-item"
    }
  })] : _vm._e()], 2), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.title'),
      "subtitle": _vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.description')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_vm.canWriteViews ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "data-cy": "create_button"
          },
          on: {
            "click": function ($event) {
              _vm.showCreateDialog = true;
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.create')) + "\n      ")]) : _vm._e(), _c('core-account-filter', {
          attrs: {
            "default": [],
            "multiple": ""
          },
          on: {
            "change": _vm.accountSelectionChanged,
            "accounts-loaded": _vm.accountsLoaded
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_vm.firstFetch ? [_c('div', {
    staticClass: "view-card-grid"
  }, _vm._l(_vm.iteratorPerPage, function (i) {
    return _c('core-virtual-device-smart-group-card-skeleton', {
      key: `skeleton-${i}`
    });
  }), 1)] : !_vm.isFetchingList && _vm.hasNoMonitoringViews ? [_c('core-empty-state', {
    attrs: {
      "icon": "fa-object-group",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.emptyState.title')) + "\n            ")];
      },
      proxy: true
    }])
  }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.monitoringViews.emptyState.description')) + "\n            ")])])] : [_c(VDataIterator, {
    attrs: {
      "items": _vm.currentPageItems,
      "items-per-page": _vm.iteratorPerPage,
      "page": 1,
      "server-items-length": _vm.totalCount,
      "hide-default-header": "",
      "hide-no-data": "",
      "footer-props": {
        itemsPerPageText: _vm.$i18n_t('Common.itemsPerPage'),
        itemsPerPageOptions: [12, 24]
      }
    },
    on: {
      "update:items-per-page": _vm.handleItemsPerPageChange,
      "update:page": _vm.handlePageChange
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (props) {
        return [_c('div', {
          staticClass: "view-card-grid"
        }, _vm._l(props.items, function (view) {
          return _c('div', {
            key: `view-${view.id}`
          }, [_vm.isFetchingExecute || view.isFetchingExecute !== false ? [_c('core-virtual-device-smart-group-card-skeleton', {
            key: `skeleton-${view.id}`
          })] : [_c('core-virtual-device-smart-group-card', {
            attrs: {
              "id": view.id,
              "account": view.account,
              "title": view.title,
              "devices": view.devices,
              "errors": view.errors,
              "warnings": view.warnings,
              "tags": view.tags,
              "actions": _vm.cardActions
            },
            on: {
              "delete": _vm.handleDelete,
              "edit": _vm.handleEdit
            }
          })]], 2);
        }), 0)];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n              " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + "\n              " + _vm._s(items.itemsLength) + "\n            ")];
      }
    }])
  })]], 2)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };